import { TState } from 'redux/store'
import { IToastMessage } from 'types/common/types'

export const appToastMessageSelector = (state: TState): IToastMessage | null => state.app.toastMessage
